// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  BASE_API_URL: 'https://stage.dclean.wdprapps.disney.com/',
  BASE_IMG_URL: 'https://s3.amazonaws.com/wdw-cast-cot-files-stage'
};



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/environments/environment.ts